// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropResolvedIdentityProfile } from '../models/ApiDropResolvedIdentityProfile';
import { HttpFile } from '../http/http';

export class ApiDropMetadataResponse {
    'data_key': string;
    'data_value': string;
    'resolved_profile'?: ApiDropResolvedIdentityProfile | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "data_key",
            "baseName": "data_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "data_value",
            "baseName": "data_value",
            "type": "string",
            "format": ""
        },
        {
            "name": "resolved_profile",
            "baseName": "resolved_profile",
            "type": "ApiDropResolvedIdentityProfile",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDropMetadataResponse.attributeTypeMap;
    }

    public constructor() {
    }
}
